import { useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import settings from '../../constants';

// If you need to remake the component for react-router-dom v6
// here's the snippet: https://stackoverflow.com/a/70502633
const RouteChangeFbTracker = ({ history }) => {
  useEffect(() => {
    let unlistendFB = null;
    import('react-facebook-pixel')
      .then(x => x.default)
      .then(ReactPixel => {
        ReactPixel.init(settings.facebookPixelId);
        ReactPixel.pageView();

        unlistendFB = history.listen(() => {
          ReactPixel.pageView();
        });
      });

    return () => {
      unlistendFB?.();
    };
  }, []);

  return null;
};
export default withRouter(RouteChangeFbTracker);
